<h2 mat-dialog-title>
  <i class="fa fa-exclamation-circle" style="color: #ff5619; font-size: 30px;margin-right: 5px"></i>
  Вы уверены?</h2>
<!--<mat-dialog-content>Вы уверены?</mat-dialog-content>-->
<mat-dialog-actions>
  <button style="background: #cee0ec" mat-button (click)="onNoClick()">Отмена</button>
  <button style="background: #cee0ec" mat-button [mat-dialog-close]="data.client" cdkFocusInitial>ОК</button>
</mat-dialog-actions>
